import { isAxiosError } from 'axios';
import type { HttpClient } from '@shared/http/http-client';
import type { ICaseRepository, CaseListQuery } from '@domain/data-contracts/case-repository.interface';
import type { LabCase } from '@domain/models/lab-case.interface';
import type { PagedResult } from '@domain/models/paging.interface';
import { mapCaseDto, mapPaged, type CaseDto, type PagedDto } from './mapping.helper';

const BASE = '/api/cases';

export class CaseRepository implements ICaseRepository {
  public constructor(private readonly http: HttpClient) {}

  public async search(query: CaseListQuery): Promise<PagedResult<LabCase>> {
    const response = await this.http.get<PagedDto<CaseDto>>(BASE, {
      params: pruneParams(query),
    });
    return mapPaged(response.data, mapCaseDto);
  }

  public async getByOrderId(orderId: string): Promise<LabCase | null> {
    try {
      const response = await this.http.get<CaseDto>(
        `${BASE}/by-order/${encodeURIComponent(orderId)}`,
      );
      return mapCaseDto(response.data);
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
}

function pruneParams(query: CaseListQuery): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (query.status) { out.status = query.status; }
  if (query.search && query.search.trim().length > 0) { out.search = query.search.trim(); }
  if (typeof query.page === 'number') { out.page = query.page; }
  if (typeof query.pageSize === 'number') { out.pageSize = query.pageSize; }
  return out;
}
